import RestClient from '../RestClient/RestClient';
import * as promobannerConstants from './PromotionalBannerApiConstants';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getChannel } from '../Common/CommonHelper';

export const getIrisPromotionalBannerData = (params) => { //eslint-disable-line
    /* istanbul ignore next */
    const url = `${promobannerConstants.irisPromotionalbannerUrl}${params}`;
    const context = RestClient.getContext();
    const channel = getChannel(context); // getting the channel type for IRIS
    const config = {
        url,
        excludeVersion: true,
        credentials: 'include',
        apiHost: apiHosts.content,
        isXCloudHeaderRequired: true,
        channel,
    };
    return RestClient.get(config).then((json) => json);
};
